import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import mobileApplicationReleaseProfileService from '../../services/mobileApplicationReleaseProfileService';
import MobileApplicationReleaseProfileForm from './MobileApplicationReleaseProfileForm';
import BuildApiKeyRevealDialog from './BuildApiKeyRevealDialog';

const MobileApplicationReleaseProfileEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);
  const [entity, setEntity] = useState<any>({ id: 0 });
  const [revealedKey, setRevealedKey] = useState('');
  const [keyDialogOpen, setKeyDialogOpen] = useState(false);
  const { canPlatform } = useCheckPermission();
  const canManage = canPlatform(['ManageBuildProfiles']);

  useEffect(() => {
    mobileApplicationReleaseProfileService
      .get(Number(params.id))
      .then((response: any) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          setEntity(response.result);
        }
      });
  }, [params.id]);

  const onSubmit = (values: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    mobileApplicationReleaseProfileService
      .update(values)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages);
          enqueueSnackbar(response.errorMessages.join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Mentve!', { variant: 'success' });
          if (response.result) {
            setEntity(response.result);
          }
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <>
      <MobileApplicationReleaseProfileForm
        entity={entity}
        readonly={!canManage}
        onSubmit={onSubmit}
        errors={errors}
        handleCancel={() => navigate(-1)}
        onApiKeyRevealed={(key: string) => {
          setRevealedKey(key);
          setKeyDialogOpen(true);
        }}
      />
      <BuildApiKeyRevealDialog
        open={keyDialogOpen}
        apiKey={revealedKey}
        title="Új API kulcs — másold el most"
        onClose={() => {
          setKeyDialogOpen(false);
          setRevealedKey('');
        }}
      />
    </>
  );
};

export default MobileApplicationReleaseProfileEdit;
